import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';

// #156: framework wiring + English catalog extraction only -- no second language, no language
// switcher, no translation-management workflow, per #137's decision record. Uses the default
// global i18next instance (no <I18nextProvider> needed) since this is a client-only SPA with no
// SSR/multi-instance concern; useTranslation() reads from this instance automatically once
// initialized.
void i18next.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  resources: { en: { translation: en } },
  interpolation: { escapeValue: false },
  returnNull: false
});

export default i18next;
